const ISO_DATE = /\b\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?\b/g;

/** Preserve the date's calendar day rather than shifting a midnight timestamp by timezone. */
export function formatInsightDate(value: string, granularity?: 'day' | 'week' | 'month'): string {
  if (!/^\d{4}-\d{2}-\d{2}(?:$|[T ])/.test(value)) return value;
  const day = value.slice(0, 10);
  const date = new Date(`${day}T12:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== day) return value;
  return new Intl.DateTimeFormat('en-US', { month: 'short', ...(granularity === 'month' ? {} : { day: 'numeric' }), year: 'numeric', timeZone: 'UTC' }).format(date);
}

export function compactInsightDates(text: string, granularity?: 'day' | 'week' | 'month'): string {
  return text.replace(ISO_DATE, value => formatInsightDate(value, granularity));
}
